import {fabric} from 'fabric'
export default { 
    data() {
      return { 
        pos: {},
        posl: {},
        setCode: 0,
      };
    },
 
    methods: { 
        initCanvas: function(canvas,midCanvas,setArr,type,sectionId){
            var that = this
            if(type !=2){
              this.canvasM = document.getElementById('midCanvas'); //画布对象
              this.contextM = this.canvasM.getContext('2d');//画布显示二维图片
            }
            
            canvas.selections = false
            // this.setGrid(canvas,"#ffffff")
            if(type==1){
              this.setUnRoad(canvas, setArr);
            }else{
              this.setRoadM(canvas,setArr,sectionId)
              this.setRoadNumText(canvas,setArr,sectionId)
            }
            if(type == 2){
              this.setCode = 2
            }
            //鼠标按下事件
            console.log(canvas)
            canvas.on("mouse:down", function(e) {
              console.log(e)
                if(e.target != null){
                    if('id' in e.target){
                        that.fabricClickId = e.target.id
                        that.fabricClickName = e.target.carName
                        let topD = e.pointer.y-80
                        let leftD = e.pointer.x
                        if(midCanvas != ''){
                            that.$refs.setCarInfo.style.top = topD+ 'px'
                            that.$refs.setCarInfo.style.left = leftD+ 'px'
                            that.$refs.setCarInfo.style.display = 'none'
                        }
                        
                    }
                }else{
                    if(midCanvas != ''){
                        that.$refs.setCarInfo.style.display = 'none'
                    }
                    
                }
                // if(e.target.id){
                //     //console.log(e.target.id)
                // }
                this.panning = true;
                // canvas.selection = false;
                if(type != 2){
                  this.pos = that.windowToCanvas(e.pointer.x, e.pointer.y);  //坐标转换，将窗口坐标转换成canvas的坐标
                }
                
            });
            //鼠标抬起事件
            canvas.on("mouse:up", function() {
                this.panning = false;
                // canvas.selection = false;
            });
            // 移动画布事件
            canvas.on("mouse:move", function(e) {
                // //console.log(canvas.getObjects())
                if (this.panning && e && e.e) {
                    var delta = new fabric.Point(e.e.movementX/that.setCode, e.e.movementY/that.setCode);
                    // this.posl = that.windowToCanvas(e.pointer.x, e.pointer.y);
                    // var x = this.posl.x - this.pos.x, y = this.posl.y - this.pos.y;
                    // console.log(x,y)
                    console.log(e.e.movementX, e.e.movementY,that.setCode)
                    // var delta = new fabric.Point(x,y);
                    canvas.relativePan(delta);
                    if(midCanvas != ''){
                        midCanvas.relativePan(delta);
                    }
                    
                }
            });
            var leftTo = canvas._offset.left
            var topTo = canvas._offset.top
            // 鼠标滚动画布放大缩小
            canvas.on("mouse:wheel", function() {
              
                //console.log(event)
                var zoom = (event.deltaY > 0 ? -0.1 : 0.1) + canvas.getZoom();
                zoom = Math.max(0.5, zoom); //最小为原来的1/10
                zoom = Math.min(20, zoom); //最大是原来的3倍
                that.$store.commit('setZoom', zoom)
                var zoomPoint = new fabric.Point(event.pageX-leftTo, event.pageY-topTo);
                canvas.zoomToPoint(zoomPoint, zoom);
                if(midCanvas != ''){
                    midCanvas.zoomToPoint(zoomPoint, zoom);
                }
                if(type==1){
                  that.setUnRoad(canvas, setArr);
                }else{
                  let canvasArr = canvas.getObjects();
                  for (let i = 0; i < canvasArr.length; i++) {
                    if (canvasArr[i].class == "roadShowArt") {
                      canvas.remove(canvasArr[i]);
                    }
                  }
                  that.setRoadNumText(canvas,setArr,sectionId)
                }
                
            });
        },
        windowToCanvas(x,y) {
          var box = this.canvasM.getBoundingClientRect();  //这个方法返回一个矩形对象，包含四个属性：left、top、right和bottom。分别表示元素各边与页面上边和左边的距离
          // console.log('box:',box)
          // console.log(x,y)
          return {
              x: x - box.left - (box.width - this.canvasM.width) / 2,
              y: y - box.top - (box.height - this.canvasM.height) / 2
          };
        },
        //标准道路详情页
        initCanvas1: function(canvas,midCanvas,setArr,type){
          var that = this
          canvas.selections = false
          // this.setGrid(canvas,"#ffffff")
          if(type == 1){
              this.setRoad1(canvas,'',setArr)
          }else{
              this.setRoad(midCanvas,canvas,setArr)
          }
          
          //鼠标按下事件
          canvas.on("mouse:down", function(e) {

              if(e.target != null){
                  if('id' in e.target){
                      that.fabricClickId = e.target.id
                      that.fabricClickType = e.target.equipType
                      that.fabricClickName = e.target.carName
                      let topD = e.pointer.y-80
                      let leftD = e.pointer.x-10
                      if(midCanvas != ''){
                          that.$refs.setCarInfo.style.top = topD+ 'px'
                          that.$refs.setCarInfo.style.left = leftD+ 'px'
                          that.$refs.setCarInfo.style.display = 'block'
                          that.curbOffset = ''
                      }
                      
                  }
              }else{
                  if(midCanvas != ''){
                      that.$refs.setCarInfo.style.display = 'none'
                  }
                  
              }
              // if(e.target.id){
              //     console.log(e.target.id)
              // }
              this.panning = true;
              // canvas.selection = false;
          });
          //鼠标抬起事件
          canvas.on("mouse:up", function() {
              this.panning = false;
              // canvas.selection = false;
          });
          // 移动画布事件
          canvas.on("mouse:move", function(e) {
              // console.log(canvas.getObjects())
              if (this.panning && e && e.e) {
                  var delta = new fabric.Point(e.e.movementX, e.e.movementY);
                  canvas.relativePan(delta);
                  if(midCanvas != ''){
                      midCanvas.relativePan(delta);
                  }
                  
              }
          });
          var leftTo = canvas._offset.left
          var topTo = canvas._offset.top
          // 鼠标滚动画布放大缩小
          canvas.on("mouse:wheel", function() {
              var zoom = (event.deltaY > 0 ? -0.1 : 0.1) + canvas.getZoom();
              zoom = Math.max(0.5, zoom); //最小为原来的1/10
              zoom = Math.min(20, zoom); //最大是原来的3倍
              that.$store.commit('setZoom', zoom)
              var zoomPoint = new fabric.Point(event.pageX-leftTo, event.pageY-topTo);
              canvas.zoomToPoint(zoomPoint, zoom);
              if(midCanvas != ''){
                  midCanvas.zoomToPoint(zoomPoint, zoom);
              }
              // that.setRoadText(midCanvas,setArr,canvas.getZoom())
          });
        },
        //roadinfo页面使用的函数
        setRoad1(canvas,tCanvas,setArr){
          let getArr = JSON.parse(JSON.stringify(setArr))
            let leftArr = getArr[0]
            let rightArr = getArr[2].reverse()
            let areaArr = leftArr.concat(rightArr)
            let areaPath = 'M'+' '+areaArr[0][0]+' '+areaArr[0][1]
            for(let i=1;i<areaArr.length;i++){
                areaPath += ' '+'L'+' '+areaArr[i][0]+' '+areaArr[i][1]
            }
            areaPath = areaPath + 'z'
            // console.log(areaPath)
            canvas.add(new fabric.Path(areaPath,{
                strokeWidth: 0,
                // stroke: 'red',
                fill: 'RGBA(132,132,198,0.3)',
                strokeDashArray: [1,1],
                selectable: false,
                hasBorders: false,
                hasControls: false,
                class: 'roadPointerInfo'
            }))
            
            for(let i=0;i<getArr[2].length;i++){
                if(i==0 || i%(parseInt(300*localStorage.getItem('scaleCode'))) == 0){
                  canvas.add(new fabric.Text(getArr[3][i],{
                        fontSize: 12,
                        top: getArr[0][i][1]*1,
                        left: getArr[0][i][0]-(30*(0.12/localStorage.getItem('scaleCode'))),   
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                        fill: 'red',
                        class: 'roadPointerInfo'
                    }).scale(0.6*(0.24/localStorage.getItem('scaleCode'))))
                }
                
            }
            getArr = []
            leftArr = []
            rightArr = []
            areaArr = []
            areaPath = ''
        },
        setGrid: function(canvas){
            //console.log(color)
            // var line = new fabric.Line([10,10,100,100],{
            //     strokeWidth: 2,
            //     stroke: 'red'
            // })
            // canvas.add(line)
            // let colorValue = color ? color : 'RGB(224,224,225)'
            canvas.clear()
            let gridSize = 50;
            let canvasWidth = canvas.width;
            let canvasHeight = canvas.height;
        
            let xLineTotal = Math.floor(canvasHeight / gridSize);
            let yLineTotal = Math.floor(canvasWidth / gridSize);
            // ctx.fillStyle = colorValue;
            // ctx.fillRect(0, 0, canvasWidth, canvasHeight);
            // ctx.stroke();
            var rectBG = new fabric.Rect({
                left: 0,
                top: 0,
                fill: '#ffffff',
                width: canvasWidth-2,
                height: canvasHeight,
                selectable: false,
                hasBorders: false,
                hasControls: false,
            }) 
            canvas.add(rectBG)
        
            for (let i = 0; i <= xLineTotal; i++) {
                canvas.add(new fabric.Line([0,i * gridSize - 0.5,canvasWidth, i * gridSize - 0.5],{
                    strokeWidth: 1,
                    stroke: '#D3D3D3',
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                }))
            }
        
            for (let i = 0; i <= yLineTotal; i++) {
                canvas.add(new fabric.Line([i * gridSize - 0.5,0,i * gridSize - 0.5, canvasHeight],{
                    strokeWidth: 1,
                    stroke: '#D3D3D3',
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                }))
            }
        },
        setRoadM(canvas,setArr,sectionId){
          
          
          let leftArr = setArr[0]
          let rightArr = setArr[2].reverse()
          let areaArr = leftArr.concat(rightArr)
          let areaPath = 'M'+' '+areaArr[0][0]+' '+areaArr[0][1]
          for(let i=1;i<areaArr.length;i++){
              areaPath += ' '+'L'+' '+areaArr[i][0]+' '+areaArr[i][1]
          }
          areaPath = areaPath + 'z'
          if(sectionId == 0 || sectionId == null || sectionId == '' || sectionId == undefined){
            canvas.add(new fabric.Path(areaPath,{
              strokeWidth: 0,
              // stroke: 'red',
              // fill: 'RGBA(132,132,198,0.3)',
              fill: 'RGBA(74, 92, 118, 0)',
              strokeDashArray: [1,1],
              selectable: false,
              hasBorders: false,
              hasControls: false,
              // class: 'roadShowArt'
            }))
          }else{
            canvas.add(new fabric.Path(areaPath,{
              strokeWidth: 0,
              // stroke: 'red',
              // fill: 'RGBA(132,132,198,0.3)',
              fill: 'RGBA(74, 92, 118, 0.3)',
              strokeDashArray: [1,1],
              selectable: false,
              hasBorders: false,
              hasControls: false,
              // class: 'roadShowArt'
            }))
          }
          
          
        },
        setRoadNumText(canvas,setArr,sectionId){
          //按缩放比例设定桩号字体大小
          let fontsize=10
          if(sectionId == 0 || sectionId == null || sectionId == '' || sectionId == undefined){
            console.log('w')
          }else{
            for(let i=0;i<setArr[2].length;i++){
              if(i==0 || i%60 == 0){
                  canvas.add(new fabric.Text(setArr[3][i],{
                      fontSize:fontsize,
                      fontFamily: "YAHEI", 
                      top: setArr[0][i][1]*1,
                      left: setArr[0][i][0]+10,   
                      selectable: false,
                      hasBorders: false,
                      hasControls: false,
                      // fill: 'red',
                      fill: 'black',
                      // textBackgroundColor:'red',
                      fontWeight:600,
                      class: 'roadShowArt'
                  }).scale(1/(this.$store.state.zoom?this.$store.state.zoom:1)))
              }
            }
          }
          
        },
        //绘制非标道路
        setUnRoad(canvas, setArr) {
            console.log('setroad1',setArr)
            let leftArr = setArr[0];
            let barArr = setArr[2];
            let getArr = setArr[3];
            let getArr1 = setArr[4]; //作业安全区
            let getArr2 = setArr[5]; //障碍安全区
            let areaArr = leftArr;
            let areaPath = "M" + " " + areaArr[0][0] + " " + areaArr[0][1];
            for (let i = 1; i < areaArr.length; i++) {
              areaPath += " " + "L" + " " + areaArr[i][0] + " " + areaArr[i][1];
            }
            areaPath = areaPath + "z";
            canvas.add(
              new fabric.Path(areaPath, {
                strokeWidth: 1,
                stroke: "black",
                fill: "RGBA(132,132,198,0)",
                // strokeDashArray: [1,1],
                selectable: false,
                hasBorders: false,
                hasControls: false,
              })
            );
            
            for (let i = 0; i < barArr.length; i++) {
              let barPath = "";
              console.log('setroad')
              for (let j = 0; j < barArr[i].length; j++) {
                if (j == 0) {
                  barPath = "M" + " " + barArr[i][0].x + " " + barArr[i][0].y;
                } else {
                  barPath += " " + "L" + " " + barArr[i][j].x + " " + barArr[i][j].y;
                }
                
                canvas.add(
                  new fabric.Text("S" + j, {
                    fontSize: 12,
                    top: barArr[i][j].y + 5,
                    left: barArr[i][j].x + 5,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: "black",
                  })
                );
                
                canvas.add(
                  new fabric.Circle({
                    radius: 3,
                    top: barArr[i][j].y - 3, //调整中心点的X轴坐标
                    left: barArr[i][j].x - 3,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: "#000",
                  })
                );
              }
              barPath = barPath + "z";
              canvas.add(
                new fabric.Path(barPath, {
                  strokeWidth: 1,
                  stroke: "black",
                  fill: "RGBA(132,132,198,0.2)",
                  // strokeDashArray: [1,1],
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                })
              );
            }
            
            for (let i = 0; i < setArr[1].length; i++) {
              canvas.add(
                new fabric.Text(
                  setArr[1][i].name +
                    "(" +
                    setArr[1][i].x +
                    "," +
                    setArr[1][i].y +
                    ")",
                  {
                    fontSize: 14,
                    top: setArr[0][i][1] * 1.05 - 20,
                    left: setArr[0][i][0] * 1.05 - 58,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: "black",
                  }
                )
              );
            }
            
            let workPath = "";
            for (let i = 0; i < getArr.length; i++) {
              if (i == 0) {
                workPath = "M" + " " + getArr[i][0] + " " + getArr[i][1];
              } else {
                workPath += " " + "L" + " " + getArr[i][0] + " " + getArr[i][1];
              }
      
              canvas.add(
                new fabric.Text("W" + [i], {
                  fontSize: 12,
                  top: getArr[i][1] + 5,
                  left: getArr[i][0] + 5,
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                  fill: "black",
                })
              );
              
              canvas.add(
                new fabric.Circle({
                  radius: 3,
                  top: getArr[i][1] - 3, //调整中心点的X轴坐标
                  left: getArr[i][0] - 3,
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                  fill: "#000",
                })
              );
            }
            workPath = workPath + "z";
            canvas.add(
              new fabric.Path(workPath, {
                strokeWidth: 1,
                stroke: "blue",
                fill: "RGBA(213,255,255,0.5)",
                // strokeDashArray: [1,1],
                selectable: false,
                hasBorders: false,
                hasControls: false,
              })
            );
            // this.setGroupFun(canvas)
            if(getArr1.lenght){
              let workPath1 = "";
              for (let i = 0; i < getArr1.length; i++) {
                if (i == 0) {
                  workPath1 = "M" + " " + getArr1[i][0] + " " + getArr1[i][1];
                } else {
                  workPath1 += " " + "L" + " " + getArr1[i][0] + " " + getArr1[i][1];
                }
              }
              workPath1 = workPath1 + "z";
              console.log('setroad1',getArr1,workPath1)
              canvas.add(
                new fabric.Path(workPath1, {
                  strokeWidth: 1,
                  stroke: "#E96B5A",
                  fill: "RGBA(132,132,198,0)",
                  strokeDashArray: [2, 1],
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                })
              );
            }
            
            console.log('setroad1',getArr2)
            if (getArr2.length) {
              for (let i = 0; i < getArr2.length; i++) {
                let workPath2 = "";
                for (let j = 0; j < getArr2[i].length; j++) {
                  if (j == 0) {
                    workPath2 = "M" + " " + getArr2[i][0].x + " " + getArr2[i][0].y;
                  } else {
                    workPath2 +=
                      " " + "L" + " " + getArr2[i][j].x + " " + getArr2[i][j].y;
                  }
                }
                workPath2 = workPath2 + "z";
                canvas.add(
                  new fabric.Path(workPath2, {
                    strokeWidth: 1,
                    stroke: "#E96B5A",
                    fill: "RGBA(132,132,198,0)",
                    strokeDashArray: [3, 1],
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                  })
                );
              }
            }
          },
          setUnRoadOne(canvas, setArr) {
            console.log('setroad1',setArr)
            let leftArr = setArr[0];
            let barArr = setArr[2];
            let getArr = setArr[3];
            let getArr1 = setArr[4]; //作业安全区
            let getArr2 = setArr[5]; //障碍安全区
            let areaArr = leftArr;
            let areaPath = "M" + " " + areaArr[0][0] + " " + areaArr[0][1];
            for (let i = 1; i < areaArr.length; i++) {
              areaPath += " " + "L" + " " + areaArr[i][0] + " " + areaArr[i][1];
            }
            areaPath = areaPath + "z";
            canvas.add(
              new fabric.Path(areaPath, {
                strokeWidth: 1,
                stroke: "black",
                fill: "RGBA(132,132,198,0)",
                // strokeDashArray: [1,1],
                selectable: false,
                hasBorders: false,
                hasControls: false,
                id: 'roadChange'
              })
            );
            
            for (let i = 0; i < barArr.length; i++) {
              let barPath = "";
              console.log('setroad')
              for (let j = 0; j < barArr[i].length; j++) {
                if (j == 0) {
                  barPath = "M" + " " + barArr[i][0].x + " " + barArr[i][0].y;
                } else {
                  barPath += " " + "L" + " " + barArr[i][j].x + " " + barArr[i][j].y;
                }
                
                canvas.add(
                  new fabric.Text("S" + j, {
                    fontSize: 12,
                    top: barArr[i][j].y + 5,
                    left: barArr[i][j].x + 5,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: "black",
                    id: 'roadChange'
                  })
                );
                
                canvas.add(
                  new fabric.Circle({
                    radius: 3,
                    top: barArr[i][j].y - 3, //调整中心点的X轴坐标
                    left: barArr[i][j].x - 3,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: "#000",
                    id: 'roadChange'
                  })
                );
              }
              barPath = barPath + "z";
              canvas.add(
                new fabric.Path(barPath, {
                  strokeWidth: 1,
                  stroke: "black",
                  fill: "RGBA(132,132,198,0.2)",
                  // strokeDashArray: [1,1],
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                  id: 'roadChange'
                })
              );
            }
            
            for (let i = 0; i < setArr[1].length; i++) {
              canvas.add(
                new fabric.Text(
                  setArr[1][i].name +
                    "(" +
                    setArr[1][i].x +
                    "," +
                    setArr[1][i].y +
                    ")",
                  {
                    fontSize: 14,
                    top: setArr[0][i][1] * 1.05 - 20,
                    left: setArr[0][i][0] * 1.05 - 58,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: "black",
                    id: 'roadChange'
                  }
                )
              );
            }
            
            let workPath = "";
            for (let i = 0; i < getArr.length; i++) {
              if (i == 0) {
                workPath = "M" + " " + getArr[i][0] + " " + getArr[i][1];
              } else {
                workPath += " " + "L" + " " + getArr[i][0] + " " + getArr[i][1];
              }
      
              canvas.add(
                new fabric.Text("W" + [i], {
                  fontSize: 12,
                  top: getArr[i][1] + 5,
                  left: getArr[i][0] + 5,
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                  fill: "black",
                  id: 'roadChange'
                })
              );
              
              canvas.add(
                new fabric.Circle({
                  radius: 3,
                  top: getArr[i][1] - 3, //调整中心点的X轴坐标
                  left: getArr[i][0] - 3,
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                  fill: "#000",
                  id: 'roadChange'
                })
              );
            }
            workPath = workPath + "z";
            canvas.add(
              new fabric.Path(workPath, {
                strokeWidth: 1,
                stroke: "blue",
                fill: "RGBA(255,0,0,0.3)",
                // strokeDashArray: [1,1],
                selectable: false,
                hasBorders: false,
                hasControls: false,
                id: 'roadChange'
              })
            );
            // this.setGroupFun(canvas)
            if(getArr1.lenght){
              let workPath1 = "";
              for (let i = 0; i < getArr1.length; i++) {
                if (i == 0) {
                  workPath1 = "M" + " " + getArr1[i][0] + " " + getArr1[i][1];
                } else {
                  workPath1 += " " + "L" + " " + getArr1[i][0] + " " + getArr1[i][1];
                }
              }
              workPath1 = workPath1 + "z";
              console.log('setroad1',getArr1,workPath1)
              canvas.add(
                new fabric.Path(workPath1, {
                  strokeWidth: 1,
                  stroke: "#E96B5A",
                  fill: "RGBA(132,132,198,0)",
                  strokeDashArray: [2, 1],
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                  id: 'roadChange'
                })
              );
            }
            
            console.log('setroad1',getArr2)
            if (getArr2.length) {
              for (let i = 0; i < getArr2.length; i++) {
                let workPath2 = "";
                for (let j = 0; j < getArr2[i].length; j++) {
                  if (j == 0) {
                    workPath2 = "M" + " " + getArr2[i][0].x + " " + getArr2[i][0].y;
                  } else {
                    workPath2 +=
                      " " + "L" + " " + getArr2[i][j].x + " " + getArr2[i][j].y;
                  }
                }
                workPath2 = workPath2 + "z";
                canvas.add(
                  new fabric.Path(workPath2, {
                    strokeWidth: 1,
                    stroke: "#E96B5A",
                    fill: "RGBA(132,132,198,0)",
                    strokeDashArray: [3, 1],
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    id: 'roadChange'
                  })
                );
              }
            }
          },
        setGroupFun: function(canvas){
            //console.log('111')
            let path1 = [500,500,600,300]
            let patha = new fabric.Line(path1,{
                stroke: 'red'
            })
            let path2 = [600,300,700,500]
            let pathb = new fabric.Line(path2,{
                stroke: 'red'
            })
            let path3 = [700,500,800,300]
            let pathc = new fabric.Line(path3,{
                stroke: 'red'
            })
            let path4 = [800,300,900,500]
            let pathd = new fabric.Line(path4,{
                stroke: 'red'
            })
            let path5 = [900,500,1000,300]
            let pathe = new fabric.Line(path5,{
                stroke: 'red'
            })
            canvas.add(patha)
            canvas.add(pathb)
            canvas.add(pathc)
            canvas.add(pathd)
            canvas.add(pathe)
        }
    }
  };